import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonLoading, IonTabBar, IonTabButton, IonTitle, IonToast, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { closeOutline, time } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { MessageContext } from '../../../contexts/MessageContext';
import './InformacoesEmpresa.css';

type Props = {
  closeAction: Function;
}

const InformacoesEmpresa: React.FC<Props> = (props: Props) => {


  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  const [tabSelecionada, setTabSelecionada] = useState('empresa');

  const diaAtual = new Date().getDay(); // Obtém o dia da semana atual (0 = Domingo, 1 = Segunda...)

  const diasSemanaNumber: any = {
    SUNDAY: 0,
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6
  };

  useIonViewDidEnter(() => {

  })

  // Função para formatar telefone
  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }

  const diasSemana: any = {
    MONDAY: 'Segunda-feira',
    TUESDAY: 'Terça-feira',
    WEDNESDAY: 'Quarta-feira',
    THURSDAY: 'Quinta-feira',
    FRIDAY: 'Sexta-feira',
    SATURDAY: 'Sábado',
    SUNDAY: 'Domingo'
  };

  const calcularHorarioFinal = (start: any, duration: any) => {
    const [hours, minutes] = start.split(':').map(Number);
    const endMinutes = minutes + duration;
    const endHours = hours + Math.floor(endMinutes / 60);
    const finalMinutes = endMinutes % 60;
    return `${endHours.toString().padStart(2, '0')}:${finalMinutes.toString().padStart(2, '0')}`;
  };

  const formatarHorario = (horario: string) => {
    return horario.split(":").slice(0, 2).join(":");
  };

  const EmpresaInfo = () => (
    <>
      <IonItem lines="none">
        <IonLabel className="ion-text-wrap"><strong>Nome:</strong> {dadosEmpresa.empresaNome}</IonLabel>
      </IonItem>
      <IonItem lines="none">
        <IonLabel className="ion-text-wrap"><strong>Endereço:</strong> {dadosEmpresa.empresaEndereco}</IonLabel>
      </IonItem >
      <IonItem lines="none">
        <IonLabel className="ion-text-wrap"><strong>Telefone:</strong> {formataTelefone(dadosEmpresa?.empresaTelefone)}</IonLabel>
      </IonItem>
      <IonItem lines="none">
        <IonLabel className="ion-text-wrap"><strong>Email:</strong> {dadosEmpresa.empresaEmail}</IonLabel>
      </IonItem>
    </>
  );

  const Horarios = () => (
    <IonList style={{ padding: "0px", margin: "0px" }}>
      {dadosEmpresa.horarios?.map((horario: any) => {
        const isHoje = diasSemanaNumber[horario.dayOfWeek] === diaAtual; // Verifica se é o dia atual

        return (
          <IonItem lines="none" key={horario.indice} style={{ padding: "0px", margin: "0px" }}>
            {/* Dia da semana */}
            <IonLabel style={{ fontWeight: isHoje ? "bold" : "normal" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                {isHoje && <IonIcon icon={time} style={{ color: "red", marginRight: "5px" }} />}
                {diasSemana[horario.dayOfWeek]}
              </div>
            </IonLabel>

            {/* Horário */}
            <IonLabel style={{ fontWeight: isHoje ? "bold" : "normal" }}>
              {formatarHorario(horario.start)} às {calcularHorarioFinal(horario.start, horario.duration)}
            </IonLabel>
          </IonItem>
        );
      })}
    </IonList>

  );

  return (
    <>

      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={() => props.closeAction()}>
              <IonIcon icon={closeOutline} />
            </IonButton>
          </IonButtons>
          <IonTitle>Informações da Empresa</IonTitle>
        </IonToolbar>

        <IonToolbar>
          <IonTabBar className="custom-tab-bar">
            <IonTabButton tab="empresa" className={tabSelecionada === 'empresa' ? 'active-tab' : ''} onClick={() => setTabSelecionada('empresa')}>
              <IonLabel>Sobre</IonLabel>
            </IonTabButton>
            <IonTabButton tab="horarios" className={tabSelecionada === 'horarios' ? 'active-tab' : ''} onClick={() => setTabSelecionada('horarios')}>
              <IonLabel>Horário</IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        {tabSelecionada === 'empresa' ? <EmpresaInfo /> : <Horarios />}
      </IonContent>

      <IonFooter className="ion-no-border">
        <IonToolbar style={{ padding: "10px" }}>
          <IonButton style={{ height: "46px", fontSize: "18px" }} onClick={() => props.closeAction()} expand="block" type="submit">Fechar</IonButton>
        </IonToolbar>
      </IonFooter>

      <IonToast
        isOpen={showToast}
        position="middle" //top, bottom, middle
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />


      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />

    </>
  );
};

export default ({ closeAction }: { closeAction: Function }) => (
  <InformacoesEmpresa closeAction={closeAction} >
  </InformacoesEmpresa>
)
